import React, { Component } from 'react';
import './Header.scss';
import { Link, withRouter } from "react-router-dom";
import aebLogo from "../../assets/img/Aeb-logo.svg";
import silLogo from "../../assets/img/ic_sil.svg";

class Header extends Component {

  constructor(props) {
    super(props);

    this.state = {
      lang: '',
    };

    const { location } = this.props
    const lng_url = location.pathname.substring(location.pathname.lastIndexOf('/') + 1, location.pathname.lastIndexOf('/') + 3);
    this.lng_switch = lng_url === 'en' ? 'hy' : 'en';
    this.lng_switch_url = lng_url === 'en' ? location.pathname.slice(0, -2) + 'hy' : location.pathname.slice(0, -2) + 'en';
  }

  render() {
    return (
      <header className="flex-container align-middle">
        <div className="row align-center fluid-x">
          <div className="column small-12 large-10">
            <div className="row align-middle align-justify">
              <div className="column small-12 medium-5">
                <div className="header_logos">
                  <Link to={`/${this.state.lang}`} className="header_logo">
                    <img src={aebLogo} alt="" />
                  </Link>

                  <a href="http://www.silinsurance.am/" className="header_logo" target="_blank" rel="noopener noreferrer">
                    <img src={silLogo} alt="" />
                  </a>
                </div>
              </div>

              <div className="column small-12 medium-5">
                <div className="header_contact text-right">
                  <span className="header_contact__icon">
                    <i className="icon icon-phone">
                    </i>
                  </span>
                  <span className="header_contact__content">
                    <a href="tel:+37410510910">
                      +374 10 510-910
                    </a>
                    <a href="tel:+37480008686">
                      +374-8000-8686
                    </a>
                    <a href={this.lng_switch_url}>
                      {this.lng_switch}
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    )
  }
}
export default withRouter(Header)
